import Image from "next/image";
import { useWebTranslation } from "translations";
import { Glyph, Icon } from "ui-kit";
import Colors from "ui-kit/colors";
import { Typography } from "ui-kit/Typography";
import { getOrg } from "utils/site";
import styles from "./Benefits.module.css";
import { FlexCol, FlexRow } from "ui-kit/Layout/Flex";
import Gutter from "ui-kit/Gutter";

type Benefit =
  | "customerService"
  | "quickPayout"
  | "appRewards"
  | "refunds"
  | "app"
  | "preventive"
  | "vetsupport";

const benefits: Record<
  Benefit,
  { icon: Glyph; title: string; description: string }
> = {
  customerService: {
    icon: "headset",
    title: "signup.benefits.customerService.title",
    description: "signup.benefits.customerService.description",
  },
  quickPayout: {
    icon: "lightning",
    title: "signup.benefits.quickPayout.title",
    description: "signup.benefits.quickPayout.description",
  },
  appRewards: {
    icon: "star-circle",
    title: "signup.benefits.appRewards.title",
    description: "signup.benefits.appRewards.description",
  },
  refunds: {
    icon: "clap",
    title: "signup.benefits.refunds.title",
    description: "signup.benefits.refunds.description",
  },
  app: {
    icon: "star-circle",
    title: "signup.benefits.app.title",
    description: "signup.benefits.app.description",
  },
  preventive: {
    icon: "graduation-cap",
    title: "signup.benefits.preventive.title",
    description: "signup.benefits.preventive.description",
  },
  vetsupport: {
    icon: "first-aid",
    title: "signup.benefits.vetsupport.title",
    description: "signup.benefits.vetsupport.description",
  },
};

const getBenefits = (): Benefit[] => {
  const org = getOrg();

  switch (org) {
    case "fra":
      return ["customerService", "quickPayout", "appRewards"];
    case "ger":
      return ["customerService", "refunds", "app"];
    case "swe":
      return ["preventive", "customerService", "vetsupport"];

    default:
      return [];
  }
};

export const Benefits = () => {
  const { t } = useWebTranslation();

  const benefitItems = getBenefits();

  if (benefitItems.length === 0) {
    return null;
  }

  return (
    <div>
      <Typography
        variant="body2"
        color="grey500"
        style={{ marginBottom: 24, marginTop: 16 }}
        component="div"
      >
        <strong>{t("about_us.why.title")}</strong>
      </Typography>

      <div className={styles.wrapper}>
        {benefitItems.map((item) => {
          const benefit = benefits[item];

          return (
            <div key={benefit.title} className={styles.container}>
              <div>
                <Icon name={benefit.icon} color={Colors.blue300} size="L" />
              </div>
              <div className={styles.textContainer}>
                <Typography variant="body2">
                  <strong>{t(benefit.title)}</strong>
                </Typography>
                <Typography variant="body3">
                  {t(benefit.description)}
                </Typography>
              </div>
            </div>
          );
        })}
        <FlexCol justifyContent="center" alignItems="center">
          <Typography variant="body1" color="grey500">
            <strong>{t("hero.pets_number")}</strong>
          </Typography>
          <Typography variant="body2" color="grey500" style={{ lineHeight: 1 }}>
            {t("hero.pets_suffix")}
          </Typography>
          <Gutter size={2} />
          <Image
            src="/images/hero-avatars.png"
            alt=""
            width={82}
            height={30}
            className={styles.avatars}
          />
        </FlexCol>
      </div>
    </div>
  );
};
